import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=253c4d4c&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=ts&"
export * from "./DateFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c4d4c",
  null
  
)

export default component.exports